<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       width="100%"
       height="100%"
       viewBox="0 0 16 16"
       xml:space="preserve"
       class="fill-current"
  >
    <g transform="matrix(1.57377,0,0,1.58204,0.121448,0.0775197)">
        <path
          d="M1,2C1.552,2 2,1.552 2,1C2,0.448 1.552,0 1,0C0.448,0 0,0.448 0,1C0,1.552 0.448,2 1,2ZM1,6C1.552,6 2,5.552 2,5C2,4.448 1.552,4 1,4C0.448,4 0,4.448 0,5C0,5.552 0.448,6 1,6ZM2,9C2,9.552 1.552,10 1,10C0.448,10 0,9.552 0,9C0,8.448 0.448,8 1,8C1.552,8 2,8.448 2,9ZM3,1.5L10,1.5L10,0.5L3,0.5L3,1.5ZM10,5.5L3,5.5L3,4.5L10,4.5L10,5.5ZM3,9.5L10,9.5L10,8.5L3,8.5L3,9.5Z"
        />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'BulletsIcon'
}
</script>
